import React from "react";
import { useFormikContext } from "formik";

export default function CheckboxGroup({ children, name }) {
  const { errors, touched } = useFormikContext();
  return (
    <div>
      {children}
      {Object.prototype.hasOwnProperty.call(touched, name) &&
      Object.prototype.hasOwnProperty.call(errors, name) ? (
        <div>
          <small className="p-invalid">{errors[name]}</small>
        </div>
      ) : null}
    </div>
  );
}
